let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5A56H"), load("daCag"), load("5kHnW"), load("4UPrd"), load("kXMKO")]).then(() => parcelRequire('QvxZa'));